import { axiosBasic } from "../../../api/axios";
import { config } from "../../../api/endPoints";

const { Ticket } = config.REST_API;

const unwrap = (res) => {
  const body = res?.data;
  if (body && typeof body === "object" && "success" in body && body.success === false) {
    throw new Error(body.message || "Request failed");
  }
  return body?.data ?? body;
};

const unwrapWithTotal = (res) => {
  const body = res?.data;
  if (body && typeof body === "object" && "success" in body && body.success === false) {
    throw new Error(body.message || "Request failed");
  }
  return {
    items: body?.data ?? [],
    total: Number(body?.total ?? 0),
  };
};

export const TICKET_STATUS = {
  Open: 0,
  InProgress: 1,
  Resolved: 2,
  Closed: 3,
};

export const TICKET_PRIORITY = {
  Low: 0,
  Medium: 1,
  High: 2,
  Critical: 3,
};

export const ticketStatusLabel = (status) => {
  const map = {
    [TICKET_STATUS.Open]: "Open",
    [TICKET_STATUS.InProgress]: "In Progress",
    [TICKET_STATUS.Resolved]: "Resolved",
    [TICKET_STATUS.Closed]: "Closed",
  };
  return map[Number(status)] ?? "Unknown";
};

export const ticketPriorityLabel = (priority) => {
  const map = {
    [TICKET_PRIORITY.Low]: "Low",
    [TICKET_PRIORITY.Medium]: "Medium",
    [TICKET_PRIORITY.High]: "High",
    [TICKET_PRIORITY.Critical]: "Critical",
  };
  return map[Number(priority)] ?? "Medium";
};

export const getMyTickets = (includeResolved = true) =>
  axiosBasic.get(Ticket.Mine, { params: { includeResolved } }).then(unwrap);

export const searchCompanyTickets = (params = {}) =>
  axiosBasic.get(Ticket.Company, { params }).then(unwrapWithTotal);

export const getTicket = (id) =>
  axiosBasic.get(`${Ticket.DetailBase}${encodeURIComponent(id)}`).then(unwrap);

export const createTicket = (payload) =>
  axiosBasic.post(Ticket.Create, payload).then(unwrap);

export const addTicketComment = (payload) =>
  axiosBasic.post(Ticket.Comments, payload).then(unwrap);

export const updateTicket = (payload) =>
  axiosBasic.post(Ticket.Update, payload).then(unwrap);
